export default __webpack_public_path__ + "static/media/concussiveblast.8f467230.png";